import { render, staticRenderFns } from "./TopluGenelTalepHazirlaView.vue?vue&type=template&id=082e60c5"
import script from "./TopluGenelTalepHazirlaView.vue?vue&type=script&lang=ts"
export * from "./TopluGenelTalepHazirlaView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports